<div class="modalBackground">
  <div class="modal" [ngStyle]="{'height.px': !!height ? height : null}">
    <button class="modalClose" tabindex="0" aria-label="Close pop-up" (click)="closeModal()" #closeButton>&times;</button>
      <ng-content></ng-content>
  </div>
</div>
